module.exports = __webpack_public_path__ + "img/Basementwall_s0_b2_0_1_C00_UK.00054d82.png";